import styled from "styled-components";

const Wrapper = styled.nav`

    @media screen and (max-width: 1000px) {
        display : none;
    }
    ul{
        list-style: none;
        display : flex;
        margin : 0;
        gap : 20px;
        li{
            border-bottom : solid 4px #fff;
            color : #6c6c6c;
            padding : 0px;
            height : 86px;
            line-height : 110px;
            cursor : pointer;
            font-weight : 300;
            &.active{
                color : #2251FF;
                border-bottom : solid 4px #2251FF;
            }
        }
    }
`

export default Wrapper